import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option, OptionDescription } from 'shared/types/general';
import { ISector } from '../types';
import { operationalUnitService } from 'features/settings/topology/api/operational-unit.service';
import { productService } from 'shared/services';

interface FormParams {
  sector: ISector;
  onSubmit: any;
  disableEdit?: boolean;
}

function SectorForm({ sector, onSubmit, disableEdit }: FormParams) {
  const { t } = useTranslation();

  const [operationalUnit, setOperationalUnits] = useState<Option[]>([]);
  const [products, setProducts] = useState<OptionDescription[]>([]);

  useEffect(() => {
    operationalUnitService.getAllBaseInformation().then(setOperationalUnits);
    productService.getAllBaseInformation().then(setProducts);
  }, []);

  return (
    <div>
      {sector && (
        <>
          <EnhancedForm onSubmit={onSubmit} edit={!!sector.id} autoStyleLayout columns={2}>
            <IdentityField
              name="code"
              initialValue={sector.code}
              component={TextFieldAdapter}
              label={t('global.code')}
              type="text"
              validate={required}
              disabled={disableEdit}
            />

            <IdentityField
              name="description"
              initialValue={sector.description}
              component={TextFieldAdapter}
              label={t('global.description')}
              type="text"
              validate={required}
              disabled={disableEdit}
            />

            {operationalUnit && (
              <IdentityField
                name="operational_unit"
                component={AutocompleteAdapter}
                initValue={operationalUnit.find((s) => s.id === sector.operational_unit)}
                defaultValue={sector.operational_unit}
                options={operationalUnit}
                label={t('global.operational_unit')}
                type="text"
                disabled={disableEdit}
              />
            )}
          </EnhancedForm>
        </>
      )}
    </div>
  );
}

export default SectorForm;
